module.exports = __webpack_public_path__ + "static/media/Recruitments02.1cf12c4c.png";